import { currentTime } from './currentTime';

interface RecentCall {
  phoneNumber: string | undefined;
  isInbound: boolean;
  currentTimeStamp: string;
}

export const addRecentCallsToLocalStorage = (contact: connect.Contact): void => {
  const phoneNumber = contact.getActiveInitialConnection()?.getEndpoint().phoneNumber;
  const isInbound = contact.isInbound();
  const currentTimeStamp = currentTime();

  const recentCalls = JSON.parse(localStorage.getItem('recentCalls') || '[]') as RecentCall[];

  if (recentCalls.length > 20) {
    recentCalls.pop();
  }

  recentCalls.unshift({ phoneNumber, isInbound, currentTimeStamp });
  localStorage.setItem('recentCalls', JSON.stringify(recentCalls));
};
